import React from "react";
import { makeStyles } from "tss-react/mui";
// import { withPixelLineHeight } from '../../../base/styles/functions.web';
import AbstractPollResults from "../AbstractPollResults";
import { BUTTON_TYPES } from "../../../base/ui/constants.any";
import Button from "../../../base/ui/components/web/Button";
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            margin: "24px",
            padding: "16px",
            backgroundColor: "#303030",
            borderRadius: "10px",
            wordBreak: "break-word",
        },
        header: {
            marginBottom: "16px",
        },
        question: {
            // ...withPixelLineHeight(theme.typography.heading6),
            // color: '#FFF',
            color: "#fff",
            marginBottom: "8px",
        },
        creator: {
            // ...withPixelLineHeight(theme.typography.bodyShortRegular),
            color: "#C2C2C2",
            fontWeight: 600,
            margin: "4px 0 16px 0",
        },
        resultList: {
            listStyleType: "none",
            margin: 0,
            padding: 0,
            "& li": {
                marginBottom: "16px",
            },
        },
        answerName: {
            display: "flex",
            flexShrink: 1,
            overflowWrap: "anywhere",
            // ...withPixelLineHeight(theme.typography.bodyShortRegular),
            color: "white",
            marginBottom: "4px",
        },
        answerResultContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minWidth: "10em",
        },
        barContainer: {
            backgroundColor: "#616161",
            borderRadius: "4px",
            height: "6px",
            maxWidth: "160px",
            width: "158px",
            flexGrow: 1,
            marginTop: "2px",
        },
        bar: {
            height: "6px",
            borderRadius: "4px",
            backgroundColor: "#0056E0",
        },
        voteCount: {
            flex: 1,
            textAlign: "right",
            // ...withPixelLineHeight(theme.typography.bodyShortBold),
            color: "white",
        },
        voters: {
            margin: 0,
            marginTop: "4px",
            listStyleType: "none",
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            padding: "8px 16px",
            fontWeight: "lighter",
            border: "#616161 solid 1px",
            backgroundColor: "#616161",
            "& li": {
                // ...withPixelLineHeight(theme.typography.bodyShortRegular),
                // color: '#FFF',
                margin: 0,
                marginBottom: "2px",
                "&:last-of-type": {
                    marginBottom: 0,
                },
            },
        },
        buttonsContainer: {
            display: "flex",
            justifyContent: "space-between",
        },
        visitorBadge: {
            display: "inline-block",
            marginLeft: "6px",
            padding: "0 6px",
            borderRadius: "8px",
            backgroundColor: "#f8b500",
            color: "#222",
            fontSize: "10px",
            fontWeight: 600,
            lineHeight: "16px",
            verticalAlign: "middle",
            textTransform: "uppercase",
        },
    };
});
/**
 * Component that renders the poll results.
 *
 * @param {Props} props - The passed props.
 * @returns {React.Node}
 */
const PollResults = ({ answers, changeVote, creatorName, creatorSource, haveVoted, showDetails, question, t, toggleIsDetailed, }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.header },
            React.createElement("div", { className: classes.question }, question),
            React.createElement("div", { className: classes.creator },
                t("polls.by", { name: creatorName }),
                creatorSource === "visitor" && (React.createElement("span", { className: classes.visitorBadge }, t("visitors.chatIndicator", "Visitor"))))),
        React.createElement("ul", { className: classes.resultList }, answers.map(({ name, percentage, voters, voterCount }, index) => (React.createElement("li", { key: index },
            React.createElement("div", { className: classes.answerName }, name),
            React.createElement("div", { className: classes.answerResultContainer },
                React.createElement("span", { className: classes.barContainer },
                    React.createElement("div", { className: classes.bar, style: { width: `${percentage}%` } })),
                React.createElement("div", { className: classes.voteCount },
                    voterCount,
                    " (",
                    percentage,
                    "%)")),
            showDetails && voters && voterCount > 0 && (React.createElement("ul", { className: classes.voters }, voters.map((voter) => (React.createElement("li", { key: voter === null || voter === void 0 ? void 0 : voter.id }, voter === null || voter === void 0 ? void 0 :
                voter.name,
                (voter === null || voter === void 0 ? void 0 : voter.source) === "visitor" && (React.createElement("span", { className: classes.visitorBadge }, t("visitors.chatIndicator", "Visitor")))))))))))),
        React.createElement("div", { className: classes.buttonsContainer },
            React.createElement(Button, { accessibilityLabel: showDetails
                    ? t("polls.results.hideDetailedResults")
                    : t("polls.results.showDetailedResults"), className: "poll-button poll-button-secondary poll-button-shortest", labelKey: showDetails
                    ? "polls.results.hideDetailedResults"
                    : "polls.results.showDetailedResults", onClick: toggleIsDetailed, type: BUTTON_TYPES.SECONDARY }),
            React.createElement(Button, { accessibilityLabel: haveVoted
                    ? t("polls.results.changeVote")
                    : t("polls.results.vote"), className: "poll-button poll-button-secondary poll-button-shortest", labelKey: haveVoted
                    ? "polls.results.changeVote"
                    : "polls.results.vote", onClick: changeVote, type: BUTTON_TYPES.SECONDARY }))));
};
/*
 * We apply AbstractPollResults to fill in the AbstractProps common
 * to both the web and native implementations.
 */
export default AbstractPollResults(PollResults);
